import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from '../Modal';
import { apiPost } from '../../lib/api';

// Public "buy a plan" entry. Stripe checkout when configured; else manual signup
// → /welcome explaining next steps for the customer.
export default function SignupModal({ plan, billingCycle, onClose }) {
  const history = useHistory();
  const [form, setForm] = useState({ name: '', email: '', company: '', message: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  if (!plan) return null;

  function update(field) {
    return (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  }

  async function submit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      setError('Name and email are required.');
      return;
    }
    setError('');
    setBusy(true);
    try {
      const res = await apiPost('/signups/checkout', {
        name: form.name.trim(),
        email: form.email.trim(),
        company: form.company.trim() || null,
        plan_key: plan.key,
        billing_cycle: billingCycle ? 'annual' : 'monthly',
        message: form.message.trim() || null,
      });
      if (res.mode === 'checkout' && res.checkout_url) {
        window.location.href = res.checkout_url;
        return;
      }
      onClose();
      history.push('/welcome');
    } catch (err) {
      setError(String(err.message || err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal title={`Get started with ${plan.name}`} onClose={onClose}>
      <form onSubmit={submit}>
        <p className="bulk-import__hint">
          {plan.key === 'enterprise'
            ? "Tell us a bit about your team and we'll follow up with a custom quote."
            : `Next: we confirm your ${plan.name} request, set up your workspace, then you sign in and run skills.`}
        </p>
        <div className="form-grid">
          <label className="field-label">
            Name
            <input className="field-input" style={{ width: '100%' }} value={form.name} onChange={update('name')} required />
          </label>
          <label className="field-label">
            Work email
            <input type="email" className="field-input" style={{ width: '100%' }} value={form.email} onChange={update('email')} required />
          </label>
          <label className="field-label">
            Company
            <input className="field-input" style={{ width: '100%' }} value={form.company} onChange={update('company')} />
          </label>
          <label className="field-label">
            Message <span className="cell-muted">(optional)</span>
            <textarea className="field-input" style={{ width: '100%' }} rows={3} value={form.message} onChange={update('message')} />
          </label>
        </div>
        {error && <p className="status status--error">{error}</p>}
        <div style={{ display: 'flex', gap: '0.6rem', marginTop: '1rem' }}>
          <button type="submit" className="btn-primary" disabled={busy}>
            {busy ? 'Submitting…' : plan.key === 'enterprise' ? 'Request quote' : 'Continue'}
          </button>
          <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
}
